import { debounce } from "../utils/performance";
import { updateQueryParam, getQueryParams, getQueryParamsValues } from "../utils/queryParams";
import { setAriaExapndedAttribute, setInertAttribute, setExpendableAttributes } from "../utils/accessibility";

export default function(el) {
    const tabsWrapper = el.querySelector(".tabs__w");
    const toggles = el.querySelectorAll(".tabs__toggle");
    const tabs = el.querySelectorAll(".tabs__tab");
    const hasIndicator = tabsWrapper && tabsWrapper.classList.contains("tabs__w--has-indicator");
    const queryParamKey = el.dataset.queryParamKey;
    const queryParams = queryParamKey && getQueryParams();
    let previousIndex = null;

    const toggleTab = (index, state = true) => {
        const tab = tabs[index];
        const toggle = toggles[index];
        const actionType = state === true ? "add" : "remove";

        if (!toggle || !tab) return;

        tab.classList[actionType]("tabs__tab--active");
        toggle.classList[actionType]("tabs__toggle--active");

        if (hasIndicator && actionType == "add") moveIndicator(toggle);
        if (queryParamKey) updateQueryParam(queryParams, queryParamKey, toggle.dataset.queryValue);

        setInertAttribute(tab, state);
        setAriaExapndedAttribute(toggle, state);
    };

    const moveIndicator = (toggle) => {
        tabsWrapper.scrollTo({
            top: 0,
            left: toggle.offsetLeft,
            behavior: "smooth",
        });

        tabsWrapper.setAttribute(
            "style",
            `--tts-indicator-x: ${toggle.offsetLeft}px; --tts-indicator-w: ${toggle.offsetWidth / 100};`
        );
    };

    const openDefaultTab = () => {
        const togglesArr = Array.from(toggles);
        let index = 0;
        let defaultActiveIndex = 0;

        defaultActiveIndex = togglesArr.findIndex((t) => t.dataset.isActive && t.dataset.isActive == "true"); // First try to get index of an element with isActive dataset value set to TRUE

        // If not found, search by a query param value
        if (defaultActiveIndex === -1 && queryParamKey) {
            const queryValues = getQueryParamsValues(queryParams);

            if (queryValues[queryParamKey]) {
                defaultActiveIndex =
                    togglesArr.findIndex(
                        (t) => t.dataset.queryValue && t.dataset.queryValue === queryValues[queryParamKey]
                    ) || 0;
            }
        }

        if (defaultActiveIndex !== -1) index = defaultActiveIndex;

        toggleTab(index);
        previousIndex = index;
    };

    const handleToggleClick = (index) => {
        if (index === previousIndex) return;

        toggleTab(previousIndex, false);
        toggleTab(index);

        previousIndex = index;
    };

    const handleResizeEvent = debounce(() => {
        moveIndicator(toggles[previousIndex]);
    }, 100);

    if (toggles.length === 0 && tabs.length === 0) return;

    openDefaultTab();

    toggles.forEach((toggle, index) => {
        setExpendableAttributes(toggle, tabs[index], index === previousIndex);

        toggle.addEventListener("click", handleToggleClick.bind(null, index));
    });

    if (hasIndicator) window.addEventListener("resize", handleResizeEvent);
}
